
import { formatTimestamp } from "../../utlis/function";

const OrderCard = ({ title, location, status, orderData }) => {
  return (
    <div className="border-b border-gray-200 pb-15 last:border-b-0 last:pb-0">
      {/* Title, Location and Status */}
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="text-2xl font-semibold text-black mb-1">
            {title}
          </h3>
          <div className="flex items-center gap-2">
                 <svg
              className="w-4 h-4 text-textcolor mt-0.5 flex-shrink-0"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.5 8.33334C17.5 14.1667 10 19.1667 10 19.1667C10 19.1667 2.5 14.1667 2.5 8.33334C2.5 6.34421 3.29018 4.4366 4.6967 3.03007C6.10322 1.62355 8.01088 0.833344 10 0.833344C11.9891 0.833344 13.8968 1.62355 15.3033 3.03007C16.7098 4.4366 17.5 6.34421 17.5 8.33334Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 10.8333C11.3807 10.8333 12.5 9.71406 12.5 8.33334C12.5 6.95263 11.3807 5.83334 10 5.83334C8.61929 5.83334 7.5 6.95263 7.5 8.33334C7.5 9.71406 8.61929 10.8333 10 10.8333Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p className="text-base font-normal text-textcolor">
              {location}
            </p>
          </div>
        </div>
        <span className="px-3 py-1 bg-[#D7FFD8] text-[#007405] text-sm font-medium rounded-md">
          {status}
        </span>
      </div>

      {/* Order Details Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Order ID */}
        <div className="flex flex-col gap-2">
          <label className="text-sm font-normal text-textcolor">
            Order ID
          </label>
          <div className="px-4 py-3 bg-white border border-gray-200 rounded-lg text-black font-normal text-base">
            {orderData?.id || "-"}
          </div>
        </div>

        {/* Plan/ Duration */}
        <div className="flex flex-col gap-2">
          <label className="text-sm font-normal text-textcolor">
            Plan/ Duration
          </label>
          <div className="px-4 py-3 bg-white border border-gray-200 rounded-lg text-black font-normal text-base">
            {orderData?.subscriptionDuration> 1 ? `${orderData?.subscriptionDuration} months - ${orderData?.displayDurationSeconds}sec` : `${orderData?.subscriptionDuration} month - ${orderData?.displayDurationSeconds}sec`}
          </div>
        </div>

        {/* Amount Paid */}
        <div className="flex flex-col gap-2">
          <label className="text-sm font-normal text-textcolor">
            Amount Paid
          </label>
          <div className="px-4 py-3 bg-white border border-gray-200 rounded-lg text-black font-normal text-base">
            {orderData?.totalSubscriptionFee ? `$${orderData?.totalSubscriptionFee}`: "-"}
          </div>
        </div>

        {/* Start Date */}
        <div className="flex flex-col gap-2">
          <label className="text-sm font-normal text-textcolor">
            Start Date
          </label>
          <div className="px-4 py-3 bg-white border border-gray-200 rounded-lg text-black font-normal text-base">
            {formatTimestamp(orderData?.subscriptionStartDate)}
          </div>
        </div>

        {/* Payment Method */}
        <div className="flex flex-col gap-2">
          <label className="text-sm font-normal text-textcolor">
            Payment Method
          </label>
          <div className="px-4 py-3 bg-white border border-gray-200 rounded-lg text-black font-normal text-base">
            {orderData?.paymentMethod || "Stripe"}
          </div>
        </div>

        {/* Add-ons */}
        <div className="flex flex-col gap-2">
          <label className="text-sm font-normal text-textcolor">
            Add-ons
          </label>
          <div className="px-4 py-3 bg-white border border-gray-200 rounded-lg text-black font-normal text-base">
           { (orderData?.geoTargetFee > 0 || orderData?.geoTargetRecFee > 0) ? `$${orderData?.geoTargetFee ?? "0.00"} + $${orderData?.geoTargetRecFee ?? "0.00"}` : "-"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderCard;
